
(function () {
  function initCrosspointAddressEdit() {
    if (!/^\/pages\/address-edit\/?$/.test(window.location.pathname)) {
      return;
    }

    var ajaxErrorId = '#cp-address-ajax-error-message';
    var messageId = '#cp-address-complete-message';

    function showMessage(text) {
      illiJq(messageId).removeClass('hide').text(text);
    }

    function showError(text) {
      illiJq(ajaxErrorId).removeClass('hide').text(text);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function clearGlobalMessages() {
      illiJq(ajaxErrorId).addClass('hide').text('');
      illiJq(messageId).addClass('hide').text('');
    }

    function startRequest() {
      illiJq(window).on('beforeunload.cpAddressEdit', function (e) {
        e.preventDefault();
        return '';
      });
    }

    function endRequest() {
      illiJq(window).off('beforeunload.cpAddressEdit');
    }

    function reloadWithMessage(message) {
      endRequest();
      window.sessionStorage.setItem('cpAddressCompleteMessage', message);
      window.location.reload();
    }

    function restoreMessage() {
      var message = window.sessionStorage.getItem('cpAddressCompleteMessage');
      if (message) {
        window.sessionStorage.removeItem('cpAddressCompleteMessage');
        showMessage(message);
      }
    }

    function setFormBusy(form, busy) {
      form.find('button').prop('disabled', busy);
      form.find('button').toggleClass('btn-disable', busy);
    }

    function clearFormErrors(form) {
      form.find('.form__message').addClass('hide');
      form.find('.input--error').removeClass('input--error');
    }

    function setFormErrors(form, messages) {
      if (!messages || typeof messages !== 'object') {
        showError('住所の更新に失敗しました。時間をあけて再度お試しください。');
        return;
      }
      var inputMap = {
        last_name: '[name="address[last_name]"]',
        first_name: '[name="address[first_name]"]',
        zip: '[name="address[zip]"]',
        province: '[name="address[province]"]',
        city: '[name="address[city]"]',
        address1: '[name="address[address1]"]',
        address2: '[name="address[address2]"]',
        phone: '[name="address[phone]"]'
      };
      Object.keys(messages).forEach(function (key) {
        var selector = inputMap[key];
        if (!selector) return;
        form.find(selector).addClass('input--error');
        form.find('[data-error-for="' + key + '"]').removeClass('hide').text(messages[key]);
      });
      showError('申し訳ございませんが、ご入力いただいた内容に不備がございます。');
    }

    function getAddressData(form) {
      return {
        last_name: form.find('[name="address[last_name]"]').val(),
        first_name: form.find('[name="address[first_name]"]').val(),
        company: form.find('[name="address[company]"]').val() || '',
        zip: form.find('[name="address[zip]"]').val(),
        country: 'Japan',
        province: form.find('[name="address[province]"]').val(),
        prefname: form.find('[name="address[province]"] option:selected').data('prefname') || '',
        city: form.find('[name="address[city]"]').val(),
        address1: form.find('[name="address[address1]"]').val(),
        address2: form.find('[name="address[address2]"]').val(),
        phone: form.find('[name="address[phone]"]').val()
      };
    }

    function executeSave(form) {
      clearGlobalMessages();
      clearFormErrors(form);
      setFormBusy(form, true);
      startRequest();

      var address = getAddressData(form);
      var requestData = {
        address_id: form.data('address-id') || '',
        set_as_default: form.find('[name="set_as_default"]').is(':checked') ? 'true' : 'false',
        address: address
      };

      illiJq.ajax({
        url: '/apps/crosspoint/check-update-address',
        type: 'POST',
        dataType: 'json',
        data: { address: address },
        timeout: 30000
      }).done(function (checkResult) {
        if (!checkResult || checkResult.status !== 'success') {
          setFormErrors(form, checkResult && checkResult.result);
          setFormBusy(form, false);
          endRequest();
          return;
        }

        illiJq.ajax({
          url: '/apps/crosspoint/address-save-v2',
          type: 'POST',
          dataType: 'json',
          data: requestData,
          timeout: 30000
        }).done(function (res) {
          if (res && res.status === 'success') {
            reloadWithMessage(requestData.address_id ? '住所を更新しました。' : '住所を追加しました。');
            return;
          }
          if (res && res.result === 'shopifyApiError') {
            showError('住所の更新に失敗しました。時間をあけて再度お試しください。');
          } else {
            setFormErrors(form, res && res.result);
          }
          setFormBusy(form, false);
          endRequest();
        }).fail(function () {
          showError('サーバーへの接続に失敗しました。時間をあけて再度お試しください。');
          setFormBusy(form, false);
          endRequest();
        });
      }).fail(function () {
        showError('サーバーへの接続に失敗しました。時間をあけて再度お試しください。');
        setFormBusy(form, false);
        endRequest();
      });
    }

    function executeSimpleAction(url, addressId, completeMessage) {
      clearGlobalMessages();
      startRequest();
      illiJq.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: { address_id: addressId },
        timeout: 30000
      }).done(function (res) {
        if (res && res.status === 'success') {
          reloadWithMessage(completeMessage);
          return;
        }
        if (res && res.result && typeof res.result === 'object' && res.result.address) {
          showError(res.result.address);
        } else {
          showError('住所の処理に失敗しました。時間をあけて再度お試しください。');
        }
        endRequest();
      }).fail(function () {
        showError('サーバーへの接続に失敗しました。時間をあけて再度お試しください。');
        endRequest();
      });
    }

    restoreMessage();

    illiJq(document).on('click.cpAddressToggle', '[data-cp-address-toggle]', function () {
      var target = illiJq('#' + illiJq(this).attr('aria-controls'));
      var open = !target.hasClass('hide');
      target.toggleClass('hide', open);
      illiJq(this).attr('aria-expanded', String(!open));
    });

    illiJq(document).on('submit.cpAddressSave', '[data-cp-address-form]', function (e) {
      e.preventDefault();
      executeSave(illiJq(this));
    });

    illiJq(document).on('click.cpAddressDefault', '[data-cp-address-default]', function () {
      var addressId = illiJq(this).data('address-id');
      if (!window.confirm('この住所をメインのお届け先住所に設定しますか？')) return;
      executeSimpleAction('/apps/crosspoint/address-default-v2', addressId, 'メインのお届け先住所を変更しました。');
    });

    illiJq(document).on('click.cpAddressDelete', '[data-cp-address-delete]', function () {
      var addressId = illiJq(this).data('address-id');
      if (!window.confirm('この住所を削除しますか？')) return;
      executeSimpleAction('/apps/crosspoint/address-delete-v2', addressId, '住所を削除しました。');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCrosspointAddressEdit);
  } else {
    initCrosspointAddressEdit();
  }
})();
